module.exports = __webpack_public_path__ + "img/kefu.bb2a7ac3.png";